var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8953_35160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8953_35160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32489 20.2596C4.87476 20.2596 4.49428 20.1042 4.18344 19.7934C3.87261 19.4825 3.71719 19.102 3.71719 18.6519V6.06736C3.71719 5.61722 3.87261 5.23674 4.18344 4.92591C4.49428 4.61507 4.87476 4.45966 5.32489 4.45966H10.9768C11.1613 4.45966 11.3157 4.52136 11.4401 4.64478C11.5646 4.7682 11.6268 4.9214 11.6268 5.10438C11.6268 5.28738 11.5646 5.44234 11.4401 5.56926C11.3157 5.69617 11.1613 5.75963 10.9768 5.75963H5.32489C5.24796 5.75963 5.17744 5.79168 5.11332 5.85578C5.04922 5.9199 5.01717 5.99042 5.01717 6.06736V18.6519C5.01717 18.7288 5.04922 18.7994 5.11332 18.8635C5.17744 18.9276 5.24796 18.9596 5.32489 18.9596H10.9768C11.1613 18.9596 11.3157 19.0213 11.4401 19.1448C11.5646 19.2682 11.6268 19.4214 11.6268 19.6044C11.6268 19.7873 11.5646 19.9423 11.4401 20.0692C11.3157 20.1961 11.1613 20.2596 10.9768 20.2596H5.32489ZM17.0095 13.0096H9.96239C9.77818 13.0096 9.62394 12.9479 9.49969 12.8245C9.37544 12.7011 9.31332 12.5479 9.31332 12.3649C9.31332 12.1819 9.37544 12.0269 9.49969 11.9C9.62394 11.7731 9.77818 11.7097 9.96239 11.7097H17.0095L15.5614 10.2616C15.423 10.1231 15.3521 9.96611 15.3489 9.79056C15.3457 9.61502 15.4166 9.45862 15.5614 9.32136C15.7063 9.18409 15.8611 9.11706 16.0258 9.12026C16.1906 9.12346 16.3422 9.19429 16.4806 9.33276L18.9498 11.802C19.1139 11.96 19.196 12.1444 19.196 12.3551C19.196 12.5658 19.1139 12.7532 18.9498 12.9173L16.4806 15.3865C16.3486 15.5186 16.2012 15.5836 16.0383 15.5817C15.8755 15.5798 15.7209 15.5096 15.5745 15.3711C15.4376 15.2327 15.3675 15.0795 15.3643 14.9115C15.3611 14.7436 15.432 14.5872 15.5768 14.4423L17.0095 13.0096Z",
    fill: "#C32051"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.58fdb2b9ba3ddd95a256f2ad4c686fe9.svg";
export { ForwardRef as ReactComponent };